import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Button from '../../../atoms/button';
import ConfigurationHeader from '../../../components/configuration_header';
import {
  renameConfiguration, cancelConfiguration,
  setActiveStep, preSaveConfiguration,
  setIOIslandCustomOutputConsumption, setPowerSupplyStep,
  addPowerSupplyGroup, renamePowerSupplyGroup,
  moveIslandBetweenPowerSupplyGroups,
  setPowerSupplyRequirements, setPowerSupplies, removePowerSupplyGroup
} from '../../configuration-management/ducks';
import { openModal, closeModal } from '../../modals/ducks';
import { stepsConfig, configurationStatuses, powerSupplySteps, power_supply_question, powerSupplyVoltageCompatibilityCriteria, surveyTypes, surveyEventTypes, eventForceShowingSurvey } from '../../../constants';
import { getStepperLabels } from '../../../utils/linear-stepper';
import I10n from '../../../features/i10n';
import Configuration from '../../../models/Configuration';
import RulesDisplayer from '../../../components/rules_displayer';
import { setApplicationParameters } from '../../../utils/application-parameters/ducks';
import { appConfiguration } from '../../../utils/app-starter';
import { showNotificationWithButton } from '../../notification/ducks';
import ApplicationFullHeader from '../../../components/application_full_header';
import Scrollbars from 'react-custom-scrollbars';
import LoadingSpinner from '../../../atoms/loading';
import OutputConsumptionStep from '../../../components/power_supply_step/output_consumption_step';
import MsxIcons from '../../msx-icons';
import RequirementsStep from '../../../components/power_supply_step/requirements_step';
import SegmentsGroupStep from '../../../components/power_supply_step/segments_group_step';
import { getQuestions } from '../../question-management/ducks';
import { getPowerSupplies, getPowerSuppliesForRequirements } from '../../get-power-supplies/ducks';
import { getSurvey } from '../../survey-management/ducks';
import Survey from '../../../components/survey';
import { exportToMyProduct, exportToMyProject } from '../../export/ducks';
import { getCartUrl } from '../../../utils/my-product';
import AddToMyProductButton from '../../../components/add_to_my_product_button';
import { logSurveyOpenEvent, logSurveySubmitEvent } from '../../../utils/analytics-logger';
import { resetCBRSelectedItems } from '../../call-by-range/ducks';
import { updateShowButtonAnimations } from '../start_configuration_screen/ducks';
import { buildMySchneiderUrl } from '../../../utils/url-builder';
import Notification from '../../notification';
import { SECONDARY_COLOR } from '../../../color-constants';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 2em);
  overflow-x: hidden;
  @media (max-width: 800px) {
    position: fixed;
    z-index: 300;
    top: 0px;left: 0px;right:0px;bottom: 0px;
    overflow: auto;
    background-color: white;
    padding: 0px;
  }
  ${props => props.fullScreenEnabled && `
    position: fixed;
    z-index: 300;
    top: 0px;left: 0px;right:0px;bottom: 0px;
    overflow: auto;
    background-color: white;
    padding: 0px;
  `}
`;

const FullScreenScrollbarWrapper = styled.div`
`;

const ScreenContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0px 24px 0px 16px;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 16px;
  padding-bottom: 10px;
  margin: 0px -16px 10px -16px;
  box-shadow: 0px 3px 6px #00000029;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
`;

const MainContentWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;
`;

const FullScreenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  position: fixed;
  bottom: 0; left: 0; right: 0;
  transform: translate3d(0,0,0);
  border-top: 2px solid #EDEDED;
  background-color: white;
`;

const HiddenNavigationButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 5px;
  background-color: white;
  border-top: 2px solid #EDEDED;
  visibility: hidden;
`;

const NavigationButtonRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CancelWrapper = styled.div`
  margin-right: 10px;
`;

const StepperScrollWrapper = styled.div`
  display: flex;
  padding-top: 10px;
  border-bottom: 2px solid #EEEDED;
  height: 45px;
  box-sizing: content-box;
`;

const StepWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #626469;
  ${props => !props.isLoading && `cursor: pointer;`}
  &:first-child {
      margin-left : auto;
  }

  &:last-child {
    margin-right : auto;
  }
`;

const StepperWrapper = styled.div`
  display: flex;
`;

const StepperBullet = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => props.disabled ? `
    background-color: #BFBFBF;
    color: white !important;
  ` : `
    background-color: ${SECONDARY_COLOR};
    background-color: var(--se-primary, ${SECONDARY_COLOR});
    color: white !important;
    color: var(--se-primary-contrast, white) !important;

  `}

  min-height: 25px; min-width: 25px;
  margin-right: 5px;
  border-radius: 50%;
`;

const StepperBulletLabel = styled.div`
  font-size: 16px;
`;

const StepLabelWrapper = styled.div`
  position: relative;
`;

const StepLabel = styled.span`
  white-space: nowrap;
  ${props => props.disabled && `
    color: #BFBFBF;
  `}
`;

const StepSelectedValueWrapper = styled.div`
  position: absolute;
  top: 15px;
  left: 0px;
  right: 0px;
  color: #BFBFBF;
  height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StepSelectedValue = styled.span``;

const StepSeparator = styled.div`
  width: 35px;
  border-bottom: 2px solid #EBEAEA;
  margin: 0px 10px;
`;

class PowerSupplyScreen extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      requirements: this.props.configuration.powerSupplyManagement.requirements || {},
      candidatePowerSupplies: [],
      powerSuppliesPayload: [],
      remainingOptions: {},
      sharedOptions: {},
      isDesktop: window.innerWidth > 800,
    };
    this._isMounted = false;
  }

  updateIsDesktop = () => {
    if (this.state.isDesktop && window.innerWidth <= 800) {
      this.setState({ isDesktop: false });
    } else if (!this.state.isDesktop && window.innerWidth > 800) {
      this.setState({ isDesktop: true });
    }
  }

  componentDidMount = () => {
    this.props.getSurvey().then(() => {
      if (this.props.showButtonAnimations?.survey) {
        window.dispatchEvent(new Event(eventForceShowingSurvey));
      }
    }).finally(() => {
      this.props.updateShowButtonAnimations();
    });
    window.addEventListener("resize", this.updateIsDesktop);
    this._isMounted = true;

    this.props.getPowerSupplyQuestions().then(() => {
      if (this.props.configuration.powerSupplyManagement.step === powerSupplySteps.segment_grouping) {
        this.getPowerSupplies();
      } else if (this.props.configuration.powerSupplyManagement.step === powerSupplySteps.consumption_estimation) {
        this.getPowerSuppliesForRequirements();
      }
    });
  }

  buildCriteriaPayload(questionsWithAnswers) {
    const payload = {};

    // Add the criteria for power supply output voltage
    payload[powerSupplyVoltageCompatibilityCriteria] = [this.props.configuration.headModule.powerSupply];

    for (const [key, answer] of Object.entries(questionsWithAnswers)) {
      try {
        payload[this.getQuestionMap()[key].criteria] = answer;
      } catch (error) {
        // Filter non existing criteria
      }
    }
    return payload;
  }

  getPowerSupplies = () => {
    const powerSupplyGroups = this.buildPowerSupplyGroups();

    this.props.getPowerSupplies(this.buildCriteriaPayload(this.state.requirements), powerSupplyGroups).then(response => {

      let newPowerSuppliesPayload = [];

      response.forEach((id, idx) => {
        if (this.state.powerSuppliesPayload[idx] && this.state.powerSuppliesPayload[idx].id === id) {
          newPowerSuppliesPayload.push(this.state.powerSuppliesPayload[idx]);
        } else {
          newPowerSuppliesPayload.push({ id, isAdded: true });
        }
      });

      this.updateStateIfMounted({ powerSuppliesPayload: newPowerSuppliesPayload });
    });
  }

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.updateIsDesktop);
    this._isMounted = false;
    this.props.closeModal();
  }

  getQuestionMap() {
    const questionMap = {};
    for (const questionCategory of this.props.questions.aggregatedQuestions) {
      for (const question of questionCategory.questions) {
        questionMap[question.questionKey] = question;
      }
    }
    return questionMap;
  }

  updateStateIfMounted(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }

  showDuplicateConfirmationModal = (callback) => {
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    if (isSaved && !this.props.configuration.allowSavedModifications) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => { this.props.closeModal(); },
          onSubmit: () => {
            this.props.closeModal();
            callback();
          },
          title: I10n.get('modal.change_saved_configuration.title'),
          text: I10n.get('modal.change_saved_configuration.body'),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    } else {
      callback();
    }
  }

  renderHeaderContent = (config) => {
    return (
      <HeaderContent>
        <ConfigurationHeader
          configuration={config}
          setConfigurationName={(name) => {
            this.props.renameConfiguration(config.id, name)
          }}
          isLoading={this.props.configurationSaver.isSaving}
          renderRangeRules={this.renderRangeRules}
        >
        </ConfigurationHeader>
      </HeaderContent>
    );
  }

  renderElectricalValueString = (inputValue) => {
    const value = parseFloat(inputValue);
    const shouldScaleConsumption = (value >= 1000.0);
    const consumptionUnit = shouldScaleConsumption ? 'A' : 'mA';

    return shouldScaleConsumption ? `${(value / 1000.0).toFixed(2)} ${consumptionUnit}` : `${parseFloat(value.toFixed(2))} ${consumptionUnit}`;
  }

  get totalConsumption() {
    let result = 0;
    this.buildIslandsConsumptionGroups().forEach(group => {
      result += ((group.controllerConsumption || 0) + (group.controllerInputsConsumption || 0) + group.modulesConsumption + group.modulesInputsConsumption + group.outputConsumption);
    });

    return result;
  }

  buildChosenRequirementsString = () => {
    let result = '';
    Object.values(this.state.requirements).forEach(answers => {
      answers.forEach(answer => {
        result += `${answer}, `;
      });
    });

    return result.length > 0 ? result.substring(0, result.length - 2) : result;
  }

  renderPowerSupplyStepper = () => {
    const isLoading = this.props.questions.isLoading || this.props.configurationSaver.isSaving || this.props.powerSupplies.isLoading;

    return (
      <StepperScrollWrapper>
        <Scrollbars>
          <StepperWrapper>
            <StepWrapper isLoading={isLoading} onClick={() => {
              if (!isLoading) {
                this.props.setPowerSupplyStep(this.props.configuration, powerSupplySteps.requirements, false);
              }
            }}>
              <StepperBullet>{this.props.configuration.powerSupplyManagement.step !== powerSupplySteps.requirements ? <MsxIcons name="done"></MsxIcons> : <StepperBulletLabel>1</StepperBulletLabel>}</StepperBullet>
              <StepLabelWrapper>
                <StepLabel>{I10n.get('screen.power_supply_screen.requirements_step.label')}</StepLabel>
                {this.props.configuration.powerSupplyManagement.step !== powerSupplySteps.requirements && <StepSelectedValueWrapper><StepSelectedValue title={this.buildChosenRequirementsString()}>{this.buildChosenRequirementsString()}</StepSelectedValue></StepSelectedValueWrapper>}
              </StepLabelWrapper>
              <StepSeparator></StepSeparator>
            </StepWrapper>
            <StepWrapper isLoading={isLoading} onClick={() => {
              if (!isLoading && !(this.props.configuration.powerSupplyManagement.step === powerSupplySteps.requirements)) {
                this.props.setPowerSupplyStep(this.props.configuration, powerSupplySteps.consumption_estimation, false).then(() => {
                  this.props.getPowerSupplyQuestions().then(() => {
                    this.getPowerSuppliesForRequirements();
                  });
                });
              }
            }}>
              <StepperBullet disabled={this.props.configuration.powerSupplyManagement.step === powerSupplySteps.requirements}>
                {this.props.configuration.powerSupplyManagement.step === powerSupplySteps.segment_grouping ? <MsxIcons name="done"></MsxIcons> : <StepperBulletLabel>2</StepperBulletLabel>}
              </StepperBullet>
              <StepLabelWrapper>
                <StepLabel disabled={this.props.configuration.powerSupplyManagement.step === powerSupplySteps.requirements}>{I10n.get('screen.power_supply_screen.output_consumption_step.label')}</StepLabel>
                {this.props.configuration.powerSupplyManagement.step === powerSupplySteps.segment_grouping && <StepSelectedValueWrapper> <StepSelectedValue title={`${I10n.get('screen.power_supply_screen.total_consumption')} ${this.renderElectricalValueString(this.totalConsumption)}`}>{`${I10n.get('screen.power_supply_screen.total_consumption')} ${this.renderElectricalValueString(this.totalConsumption)}`}</StepSelectedValue></StepSelectedValueWrapper>}
              </StepLabelWrapper>
              <StepSeparator></StepSeparator>
            </StepWrapper>
            <StepWrapper isLoading={isLoading} onClick={() => {
              if (!isLoading && !(this.props.configuration.powerSupplyManagement.step !== powerSupplySteps.segment_grouping)) {
                this.props.setPowerSupplyStep(this.props.configuration, powerSupplySteps.segment_grouping, false).then(() => {
                  this.getPowerSupplies();
                });
              }
            }}>
              <StepperBullet disabled={this.props.configuration.powerSupplyManagement.step !== powerSupplySteps.segment_grouping}><StepperBulletLabel>3</StepperBulletLabel></StepperBullet>
              <StepLabel disabled={this.props.configuration.powerSupplyManagement.step !== powerSupplySteps.segment_grouping}>{I10n.get('screen.power_supply_screen.group_step.label')}</StepLabel>
            </StepWrapper>
          </StepperWrapper>
        </Scrollbars>
      </StepperScrollWrapper>);
  }

  buildIslandsConsumptionGroups = () => {
    const config = new Configuration(this.props.configuration);

    const groups = [];
    groups.push({
      name: config.name,
      slot: 0,
      controllerConsumption: config.headModule.controllerConsumption,
      controllerInputsConsumption: config.headModule.inputConsumption,
      modulesConsumption: config.getBusConsumption(),
      modulesInputsConsumption: config.getInputsConsumption(),
      outputConsumption: config.customOutputConsumption,
      groupTotalConsumption: (config.headModule.controllerConsumption + config.headModule.inputConsumption + config.getBusConsumption() + config.getInputsConsumption() + config.customOutputConsumption)
    });
    config.ioIslands.forEach(island => {
      groups.push({
        name: island.configuration.name,
        slot: island.slot,
        modulesConsumption: island.configuration.getBusConsumption(),
        modulesInputsConsumption: island.configuration.getInputsConsumption(),
        outputConsumption: island.configuration.customOutputConsumption,
        groupTotalConsumption: (island.configuration.getBusConsumption() + island.configuration.getInputsConsumption() + island.configuration.customOutputConsumption)
      });
    });
    return groups;
  }

  buildPowerSupplyGroups = () => {
    let result = [];
    const islandsConsumptionGroups = this.buildIslandsConsumptionGroups();

    this.props.configuration.powerSupplyManagement.powerSupplyGroups.forEach(group => {
      let islands = [];
      let groupConsumption = 0;

      group.islandsSlots.forEach(slot => {
        const islandConsGrp = islandsConsumptionGroups.find(isl => isl.slot === slot);
        if (islandConsGrp) {
          islands.push({
            name: islandConsGrp.name,
            slot: islandConsGrp.slot
          });
          groupConsumption += islandConsGrp.groupTotalConsumption;
        }
      });

      result.push(
        {
          name: group.name,
          powerSupplyId: (group.powerSupply == null ? null : group.powerSupply.id),
          islands,
          consumption: groupConsumption
        }
      );
    });

    return result;
  }

  allMandatoryQuestionsAnswered = () => {
    let questions = [];
    this.props.questions.aggregatedQuestions.forEach(cat => { questions = questions.concat(cat.questions); });
    let mandatoryQuestions = questions.filter(question => question.isMandatory);

    // Remove questions where the user has answered an explicit value
    mandatoryQuestions = mandatoryQuestions.filter(question => this.state.requirements[question.questionKey] == null);
    // Remove questions where there is no criteria left to choose
    mandatoryQuestions = mandatoryQuestions.filter(question => {
      let questionOptions = [...question.options];
      if (this.state.remainingOptions[question.question] != null) {
        questionOptions = questionOptions.filter(opt => {
          return this.state.remainingOptions[question.question].includes(opt.criteriaValue) && !this.state.sharedOptions[question.question].includes(opt.criteriaValue);
        });
      }
      return questionOptions.length > 0;
    });

    return mandatoryQuestions.length === 0;
  }

  getPowerSuppliesForRequirements = () => {
    return this.props.getPowerSuppliesForRequirements(this.buildCriteriaPayload(this.state.requirements)).then((response) => {
      this.updateStateIfMounted({
        candidatePowerSupplies: response.powerSupplies,
        remainingOptions: response.remainingCriteria,
        sharedOptions: response.sharedCriteria
      });
    });;
  }

  renderMainSection = () => {
    let questions = [];
    this.props.questions.aggregatedQuestions.forEach(cat => { questions = questions.concat(cat.questions); });

    return (
      <ContentWrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        {this.renderPowerSupplyStepper()}
        {this.props.configuration.powerSupplyManagement.step === powerSupplySteps.requirements && <RequirementsStep
          getPowerSupplyQuestions={this.props.getPowerSupplyQuestions}
          getPowerSuppliesForRequirements={() => {
            return this.getPowerSuppliesForRequirements();
          }}
          questions={questions}
          questionMap={this.getQuestionMap()}
          questionsWithAnswers={this.state.requirements}
          resultsLoading={this.props.configurationSaver.isSaving || this.props.powerSupplies.isLoading}
          questionsLoading={this.props.questions.isLoading}
          onAnswerChanged={(requirements) => {
            this.setState({ requirements });
          }}
          plcVoltage={this.props.configuration.headModule?.powerSupply}
          wrapperElement={this.wrapperElement}
          remainingOptions={this.state.remainingOptions}
          sharedOptions={this.state.sharedOptions}
        ></RequirementsStep>}
        {
          this.props.configuration.powerSupplyManagement.step === powerSupplySteps.consumption_estimation && <OutputConsumptionStep
            consumptionGroups={this.buildIslandsConsumptionGroups()}
            candidatePowerSupplies={this.state.candidatePowerSupplies}
            updateGroupConsumption={(islandSlot, value) => {
              this.props.setIOIslandCustomOutputConsumption(this.props.configuration, islandSlot, value);
            }}
            isLoading={this.props.questions.isLoading || this.props.configurationSaver.isSaving || this.props.powerSupplies.isLoading}
          ></OutputConsumptionStep>
        }
        {
          this.props.configuration.powerSupplyManagement.step === powerSupplySteps.segment_grouping && <SegmentsGroupStep
            powerSupplyGroups={this.buildPowerSupplyGroups()}
            powerSupplies={this.props.powerSupplies.references}
            candidatePowerSupplies={this.state.powerSuppliesPayload}
            addPowerSupplyGroup={() => {
              this.props.addPowerSupplyGroup().then(() => {
                this.getPowerSupplies();
                this.forceUpdate();
              });
            }}
            removePowerSupplyGroup={(idxToRemove) => {
              this.props.removePowerSupplyGroup(idxToRemove).then(() => {
                this.getPowerSupplies();
                this.forceUpdate();
              });
            }}
            renamePowerSupplyGroup={(newName, idxToRename) => {
              this.props.renamePowerSupplyGroup(newName, idxToRename);
            }}
            moveIslandBetweenPowerSupplyGroups={(groupOrigin, groupDestination, islandSlot) => {
              this.props.moveIslandBetweenPowerSupplyGroups(groupOrigin, groupDestination, islandSlot).then(() => {
                this.getPowerSupplies();
                this.forceUpdate();
              });
            }}
            togglePowerSupply={(groupIdx, newAddedStatus) => {
              let newPowerSuppliesPayload = this.state.powerSuppliesPayload;
              try {
                newPowerSuppliesPayload[groupIdx].isAdded = newAddedStatus;
                this.updateStateIfMounted({ powerSuppliesPayload: newPowerSuppliesPayload });
              } catch (error) { }
            }}
            isLoading={this.props.questions.isLoading || this.props.configurationSaver.isSaving || this.props.powerSupplies.isLoading}
          >
          </SegmentsGroupStep>
        }
      </ContentWrapper >
    );
  }

  confirmationBeforeCancel = (isSaved, cancelCallback) => {
    if (!isSaved) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => {
            this.props.closeModal();
          },
          onSubmit: () => {
            cancelCallback();
            this.props.cancelConfiguration(this.props.configuration.id);
            this.props.closeModal();
          },
          title: I10n.get('screen.config_editor.modal_cancel.title'),
          text: I10n.get('screen.config_editor.modal_cancel.body'),
          cancelText: I10n.get('app.action.return'),
          submitText: I10n.get('app.action.confirm'),
        }
      });
    } else {
      cancelCallback();
    }
  }

  getStepperActions = (isSaved) => {
    const config = new Configuration(this.props.configuration);

    return [
      { action: () => { this.confirmationBeforeCancel(isSaved, this.props.backToStart); }, active: true, done: true, hidden: appConfiguration.disableCallByRangeBackToStart },
      { action: () => {
        if (this.props.callByRangeReducer?.selectedItems?.references && Object.keys(this.props.callByRangeReducer?.selectedItems?.references).length === 1) {
          this.props.openModal({
            modalType: 'confirmation',
            modalProps: {
              onCancel: () => { this.props.closeModal(); },
              onSubmit: () => {
                this.props.resetCallByRangeSelectedItems();
                this.props.closeModal();
                if (configurationStatuses.finished === this.props.configuration.status) {
                  this.props.setActiveStep(stepsConfig.head_device_selector_screen);
                } else {
                  this.props.preSaveConfiguration(this.props.configuration, stepsConfig.head_device_selector_screen);
                }
              },
              title: I10n.get('screen.start_configuration_screen.cbr.modal.filter_active.title'),
              text: I10n.get('screen.start_configuration_screen.cbr.modal.filter_active.body'),
              cancelText: I10n.get('app.action.no'),
              submitText: I10n.get('app.action.yes'),
            }
          });
        }
        else {
          this.props.setActiveStep(stepsConfig.head_device_selector_screen);
        }
      }, active: true, done: true },
      { action: () => {
        if (configurationStatuses.finished === this.props.configuration.status) {
          this.props.cancel();
        } else {
          this.props.preSaveConfiguration(this.props.configuration, stepsConfig.configuration_editor_screen);
        }
       }, active: true, done: true},
      { action: () => { }, active: true, done: config.hasPowerSupplies(), skipped: isSaved && config.canUsePowerSupply() && !config.hasPowerSupplies() // Don't display the skipped status on in progress configurations
      },
      {
        action: () => {
          if (configurationStatuses.finished === this.props.configuration.status) {
            this.props.continue();
          } else {
            this.props.openModal({
              modalType: 'confirmation',
              modalProps: {
                onCancel: () => {
                  this.props.closeModal();
                },
                onSubmit: () => {
                  this.props.preSaveConfiguration(this.props.configuration, stepsConfig.accessorize).then(() => {
                  }).catch(() => { });
                  this.props.closeModal();
                },
                title: I10n.get('modal.in_progress_power_supply_selection.title'),
                text: I10n.get('modal.in_progress_power_supply_selection.body'),
                cancelText: I10n.get('app.action.no'),
                submitText: I10n.get('app.action.yes'),
              }
            });
          }
        }, active: config.fullConfigurationHasDevicesToAccessorize(), done: isSaved,
        skipped: isSaved && !config.hasDeviceAccessorized() && !config.hasSoftwareLicenseSelection()
      },
      {
        action: () => {
          if (configurationStatuses.finished === this.props.configuration.status) {
            this.props.setActiveStep(stepsConfig.save_screen);
          } else {
            this.props.openModal({
              modalType: 'confirmation',
              modalProps: {
                onCancel: () => {
                  this.props.closeModal();
                },
                onSubmit: () => {
                  this.props.saveConfiguration(this.props.configuration).then(() => {
                    this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
                  }).catch(() => { });
                  this.props.closeModal();
                },
                title: I10n.get('modal.in_progress_power_supply_selection.title'),
                text: I10n.get('modal.in_progress_power_supply_selection.body'),
                cancelText: I10n.get('app.action.no'),
                submitText: I10n.get('app.action.yes'),
              }
            });
          }
        }, active: true, done: isSaved
      },
    ];
  }

  performAddToCart = (config) => {
    if (configurationStatuses.finished !== this.props.configuration.status) {
      this.props.saveConfigurationWithoutStepChange(this.props.configuration).then(() => {}).catch(() => { });
    }

    if (appConfiguration.isWorkspaceAvailable || appConfiguration.unifiedCheckoutAvailable) {
      this.props.exportToMyProject(config);
    } else {
      const x = this.props.exportToMyProduct(config);
      x.then(() => {
        if (window.top === window.self) {
          this.props.showNotification(
            I10n.get('add_to_my_product.notification'),
            'success',
            () => (
              <Button onClick={() => { window.open(getCartUrl(), '_blank'); }}>
                {I10n.get('add_to_my_product.notification.button')}
              </Button>
            )
          );
        }
      }).catch(() => {
        this.props.showNotification(
          I10n.get('add_to_my_product.notification.error'),
          'error'
        );
      });
    }
  }

  handleAddToMyProductAction = (config) => {
    if (config.containsPrecommercializedProducts()) {
      this.props.openModal({
        modalType: 'confirmation',
        modalProps: {
          onCancel: () => {
            this.props.closeModal();
          },
          onSubmit: () => {
            this.performAddToCart(config);
            this.props.closeModal();
          },
          title: I10n.get('important_information'),
          text: I10n.get((appConfiguration.isWorkspaceAvailable || appConfiguration.unifiedCheckoutAvailable || appConfiguration.launchFromWorkspace) ? 'precommercialized_products_warning.body.project_builder' : 'precommercialized_products_warning.body'),
          cancelText: I10n.get('app.action.cancel'),
          submitText: I10n.get('app.action.continue'),
        }
      });
    } else {
      this.performAddToCart(config);
    }
  }

  renderAddToMyProductButton = () => {
    const config = new Configuration(this.props.configuration);

    return (
      <AddToMyProductButton
        distributorAddToMyProductLabel={appConfiguration.addToMyProductLabel}
        seamlessSession={appConfiguration.seamlessSession}
        launchFromWorkspace={appConfiguration.launchFromWorkspace}
        isWorkspaceAvailable={appConfiguration.isWorkspaceAvailable}
        unifiedCheckoutAvailable={appConfiguration.unifiedCheckoutAvailable}
        disabled={this.props.export.my_product.isLoading || this.props.configurationSaver.isSaving}
        callback={() => {
          if (configurationStatuses.finished !== this.props.configuration.status) {
            this.props.openModal({
              modalType: 'confirmation',
              modalProps: {
                onCancel: () => {
                  this.props.closeModal();
                },
                onSubmit: () => {
                  this.props.closeModal();
                  this.handleAddToMyProductAction(config);
                },
                title: I10n.get('modal.in_progress_power_supply_selection.title'),
                text: I10n.get('modal.in_progress_power_supply_selection.body'),
                cancelText: I10n.get('app.action.no'),
                submitText: I10n.get('app.action.yes'),
              }
            });
          } else {
            this.handleAddToMyProductAction(config);
          }
        }}
        fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
        expandOnStart={this.props.showButtonAnimations?.addToMyProduct}
      >
      </AddToMyProductButton>
    );
  }


  /**
   * Compute the "Next" button id for Selenium automated tests.
   *
   * @returns Unique id for each substeps.
   */
  computeContinueButtonID = (disabled) => {
    let result = 'continue-button';
    if (disabled) {
      result += '-disabled';
    }
    switch (this.props.configuration.powerSupplyManagement.step) {
      case powerSupplySteps.requirements:
        result = 'requirements-' + result;
        break;
      case powerSupplySteps.consumption_estimation:
        result = 'consumption-estimation-' + result;
        break;
      case powerSupplySteps.segment_grouping:
        result = 'segment-grouping-' + result;
        break;
      default:
        break;
    }

    return result;
  }

  renderNavigationButtonSection = () => {
    const config = new Configuration(this.props.configuration);
    const canShowNext = !this.props.configurationSaver.isSaving && !this.props.powerSupplies.isLoading && !this.props.questions.isLoading;
    const nextDisabled = this.props.configuration.powerSupplyManagement.step === powerSupplySteps.requirements && !this.allMandatoryQuestionsAnswered();

    const buttons = <>
      <CancelWrapper>
        <Button
          disabled={!canShowNext}
          onClick={() => {
            switch (this.props.configuration.powerSupplyManagement.step) {
              case powerSupplySteps.requirements:
                if (configurationStatuses.finished === this.props.configuration.status) {
                  this.props.cancel();
                } else {
                  this.props.preSaveConfiguration(this.props.configuration, stepsConfig.configuration_editor_screen);
                }
                break;
              case powerSupplySteps.consumption_estimation:
                this.props.setPowerSupplyStep(this.props.configuration, powerSupplySteps.requirements, false);
                break;
              case powerSupplySteps.segment_grouping:
                this.props.setPowerSupplyStep(this.props.configuration, powerSupplySteps.consumption_estimation, false).then(() => {
                  this.props.getPowerSupplyQuestions().then(() => {
                    this.getPowerSuppliesForRequirements();
                  });
                });
                break;
              default:
            }
          }}
        >
          {I10n.get('app.action.back')}
        </Button>
      </CancelWrapper>
      {canShowNext ? <Button
        importance="emphasized"
        id={this.computeContinueButtonID(nextDisabled)}
        primary
        disabled={nextDisabled}
        onClick={event => {
          switch (this.props.configuration.powerSupplyManagement.step) {
            case powerSupplySteps.requirements:
              this.props.setPowerSupplyRequirements(this.state.requirements).then(() => {
                this.props.getPowerSupplyQuestions().then(() => {
                  this.getPowerSuppliesForRequirements();
                });
              });
              break;
            case powerSupplySteps.consumption_estimation:
              this.props.setPowerSupplyStep(this.props.configuration, powerSupplySteps.segment_grouping, true).then(() => {
                this.getPowerSupplies();
              });
              break;
            case powerSupplySteps.segment_grouping:
              if (configurationStatuses.finished === this.props.configuration.status) {
                if (config.fullConfigurationHasDevicesToAccessorize()) {
                  this.props.continue();
                } else {
                  this.props.setActiveStep(stepsConfig.save_screen);
                }
              } else {
                // Set the power supplies and then perform the check if there is any candidate accessories in the response.
                this.props.setPowerSupplies(this.state.powerSuppliesPayload).then((result) => {
                  const newConfig = new Configuration(result.configuration);
                  if (newConfig.fullConfigurationHasDevicesToAccessorize()) {
                    this.props.preSaveConfiguration(result.configuration, stepsConfig.accessorize).then(() => {
                    }).catch(() => { });
                  } else {
                    this.props.saveConfiguration(result.configuration).then(() => {
                      this.props.showNotification(I10n.get('saved_configuration.configuration_saved'), 'success', null);
                    }).catch((error) => { console.log(error); });
                  }
                }).catch((error) => { console.log(error); });
              }
              break;
            default:
          }
        }}
      >
        {I10n.get('app.action.next')}
      </Button> : <LoadingSpinner width="25px" height="25px"></LoadingSpinner>}
    </>;
    return (
      <>
        <FullScreenNavigationButtonSection>
          <NavigationButtonRow>
            {buttons}
          </NavigationButtonRow>
        </FullScreenNavigationButtonSection>
        <HiddenNavigationButtonSection>
          {buttons}
        </HiddenNavigationButtonSection>
      </>
    );
  }

  renderRangeRules = (rangeInfo) => {
    return (
      <RulesDisplayer
        openModal={this.props.openModal}
        closeModal={this.props.closeModal}
        rangeName={rangeInfo.rangeName}
        starterType={this.props.configuration.starterType}
      >
      </RulesDisplayer>
    );
  }

  setWrapperRef = element => {
    this.wrapperElement = element;
  };

  renderScreenContent = (config) => {
    return (
      <>
        <ScreenContent fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
          {this.renderHeaderContent(config)}
          <MainContentWrapper ref={this.setWrapperRef}>
            {this.renderMainSection()}
          </MainContentWrapper>
          <Notification>
          </Notification>
          {this.renderAddToMyProductButton()}
          {(window.self === window.parent || appConfiguration.showDistributorSurvey) && !this.props.survey.isLoading && <Survey
            appTitle={I10n.get('app.title.' + this.props.configuration.starterType)}
            surveyData={this.props.survey?.surveyData}
            getLabel={(key) => I10n.get(key)}
            preselectionnedAnswers={{ 'embedded_survey.choose_a_category': 'embedded_survey.step.power_supply' }}
            onOpen={() => {
              logSurveyOpenEvent(surveyEventTypes.intermediate_open, config.id, stepsConfig.power_supply);
             }}
            onSubmit={(surveyAnswers) => {
              logSurveySubmitEvent(surveyEventTypes.intermediate_sent, config.id, stepsConfig.power_supply, surveyAnswers);
            }}
            fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
            color={appConfiguration.globalStyles.secondaryColor}
          ></Survey>}
        </ScreenContent>
      </>
    );
  }

  renderWithEventualScrollBar = (screenContent) => {
    return ((this.state.isDesktop && !this.props.applicationParameters.fullScreenEnabled) ? <>{screenContent}</> : <Scrollbars>
      <FullScreenScrollbarWrapper>
        {screenContent}
      </FullScreenScrollbarWrapper>
    </Scrollbars>);
  }

  render = () => {
    const config = new Configuration(this.props.configuration);
    const isSaved = this.props.configuration.status === configurationStatuses.finished;
    return (
      <Wrapper fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}>
        <ApplicationFullHeader
          title={I10n.get('app.title.' + this.props.configuration.starterType)}
          fullScreenEnabled={this.props.applicationParameters.fullScreenEnabled}
          shouldShowLogin={appConfiguration.seamlessSession == null}
          setApplicationParameters={this.props.setApplicationParameters}
          userName={appConfiguration.seamlessSession?.name}
          goToStartPage={
            () => {
              this.confirmationBeforeCancel(isSaved, this.props.backToStart);
            }}
          applicationParameters={this.props.applicationParameters}
          steps={getStepperLabels(config.starterType)}
          activeStep={stepsConfig.power_supply}
          stepperActions={this.getStepperActions(isSaved)}
          openModal={this.props.openModal}
          closeModal={this.props.closeModal}
          disabled={this.props.configurationSaver.isSaving}
          redirectWithCBR={false}
          mySchneiderLink={buildMySchneiderUrl()}
          isSoftwareLicenseConfiguration={false}
          showPrecommWarning={this.props.configuration.showPrecommercializedProducts || config.containsPrecommercializedProducts()}
        ></ApplicationFullHeader>
        {this.renderWithEventualScrollBar(this.renderScreenContent(config))}
        {this.renderNavigationButtonSection()}
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    openModal: (modalTypeWithProps) => dispatch(openModal(modalTypeWithProps)),
    closeModal: () => dispatch(closeModal()),
    renameConfiguration: (configId, name) => dispatch(renameConfiguration(configId, name)),
    cancelConfiguration: (configId) => dispatch(cancelConfiguration(configId)),
    setActiveStep: (step) => dispatch(setActiveStep(step)),
    getPowerSupplies: (criteria, powerSupplyGroups) => dispatch(getPowerSupplies(criteria, powerSupplyGroups)),
    getPowerSuppliesForRequirements: (criteria) => dispatch(getPowerSuppliesForRequirements(criteria)),
    continue: () => dispatch(setActiveStep(stepsConfig.accessorize)),
    cancel: () => dispatch(setActiveStep(stepsConfig.configuration_editor_screen)),
    getPowerSupplyQuestions: () => dispatch(getQuestions(power_supply_question)),
    backToStart: () => dispatch(setActiveStep(stepsConfig.start_screen)),
    setApplicationParameters: (parameters) => dispatch(setApplicationParameters(parameters)),
    preSaveConfiguration: (configuration, step) => dispatch(preSaveConfiguration(configuration, configurationStatuses.finalized, step)),
    saveConfiguration: (configuration) => dispatch(preSaveConfiguration(configuration)),
    saveConfigurationWithoutStepChange: (configuration) => dispatch(preSaveConfiguration(configuration, configurationStatuses.finished, configuration.step)),
    showNotification: (text, type, buttonElement) => dispatch(showNotificationWithButton(text,type, buttonElement)),
    setIOIslandCustomOutputConsumption: (configuration, islandSlot, newCustomOutputConsumption) => dispatch(setIOIslandCustomOutputConsumption(configuration, islandSlot, newCustomOutputConsumption)),
    setPowerSupplyStep: (configuration, step, withSave) => dispatch(setPowerSupplyStep(configuration, step, withSave)),
    addPowerSupplyGroup: () => dispatch(addPowerSupplyGroup()),
    removePowerSupplyGroup: (idxToRemove) => dispatch(removePowerSupplyGroup(idxToRemove)),
    renamePowerSupplyGroup: (newName, idxToRename) => dispatch(renamePowerSupplyGroup(newName, idxToRename)),
    moveIslandBetweenPowerSupplyGroups: (groupOrigin, groupDestination, islandSlot) => dispatch(moveIslandBetweenPowerSupplyGroups(groupOrigin, groupDestination, islandSlot)),
    setPowerSupplyRequirements: (requirements) => dispatch(setPowerSupplyRequirements(requirements)),
    setPowerSupplies: (powerSuppliesPayload, step) => dispatch(setPowerSupplies(powerSuppliesPayload, step)),
    getSurvey: () => dispatch(getSurvey(surveyTypes.intermediate)),
    exportToMyProduct: (configuration) => dispatch(exportToMyProduct(configuration)),
    resetCallByRangeSelectedItems: () => dispatch(resetCBRSelectedItems()),
    exportToMyProject: (configuration) => dispatch(exportToMyProject(configuration)),
    updateShowButtonAnimations: () => dispatch(updateShowButtonAnimations({addToMyProduct: false, survey: false})),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PowerSupplyScreen);
